import '@main';

await u.domready();

const articleSwiper = new Swiper(
  '.j-article-swiper',
  {
    slidesPerView: 1,
    spaceBetween: 20,
    autoHeight: true,
    navigation: {
      nextEl: ".j-article-swiper-next",
      prevEl: ".j-article-swiper-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      }
    }
  }
);

const bookSwiper = new Swiper(
  '.j-book-swiper',
  {
    slidesPerView: 1,
    spaceBetween: 20,
    autoHeight: true,
    navigation: {
      nextEl: ".j-book-swiper-next",
      prevEl: ".j-book-swiper-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      }
    }
  }
);
